<template>
  <ion-header>
    <ion-toolbar>
      <ion-item lines="none">
        <ion-title>{{ $t('editBooking') }}</ion-title>
        <ion-icon slot="end" style="font-size: 30px;" @click="closeDialog()" :ios="closeOutline" :md="closeOutline" name="closeOutline"></ion-icon>
      </ion-item>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-card>
      <ion-card-header>
        <ion-card-title v-if="slot">
          {{ dayjs(slot.date).tz().format('DD.MM.YYYY HH:mm') }} {{ selectedRange.selectedItem.name }}
        </ion-card-title>
      </ion-card-header>
      <ion-list  v-show="selectedRange" lines="full" class="ion-no-margin">
        <ion-item>
          <ion-icon slot="start" :ios="arrowForwardCircleOutline" :md="arrowForwardCircleOutline"></ion-icon>
          <ion-label slot="start">{{$t('units')}}</ion-label>
          <ion-select v-if="selectedRange" interface="popover" slot="start" v-model="selectedInterval">
            <ion-select-option v-for="(item, index) in selectedRange.interval_selection" :key="index" :value="item">{{ item }}</ion-select-option>          
          </ion-select>
          <ion-label  v-if="selectedRange" slot="start">{{ selectedRange.interval_name }}</ion-label>
        </ion-item>
        <ion-item v-if="selectedRange && selectedRange.interval_hint != ''">
          <ion-label class="ion-text-wrap">{{ selectedRange.interval_hint }}</ion-label>
        </ion-item>
        <ion-item v-if="slot && calculatedPrice > 0">
          <h3>{{ $t('amountToPay') }}: {{ calculatedPrice.toFixed(2) }} {{ slot.currencySymbol }}</h3>
          <ion-checkbox v-if="selectedRange && selectedRange.paymentEnabled" :disabled="slot.forceRangePayment && slot.payRangefee" v-model="slot.payRangefee" slot="end"></ion-checkbox>
        </ion-item>

        <ion-list v-show="selectedRange && selectedRange.paymentEnabled && slot.payRangefee && calculatedPrice > 0">
          
          <ion-item position="stacked">{{ $t('makeAndPayRangeBooking')}}</ion-item>
          <ion-item v-if="(clubInfo && clubInfo.clubInfo && clubInfo.clubInfo.canLastschriftRange)">
              <ion-label slot="start">{{ $t('payLastschrift')}}</ion-label>
              <ion-checkbox v-model="lastschriftChecked" slot="end"></ion-checkbox>
            </ion-item>
            
            <ion-item v-if="lastschriftChecked">
              <ion-label class="ion-text-wrap">{{ $t('payLastschriftHint')}}</ion-label>
              <ion-button @click="createRangeBookingByLastschrift()" color="success">{{ $t('makeAndPayRangeBooking') }}</ion-button>
            </ion-item>

            <ion-grid class="ion-no-margin ion-no-padding">
              <ion-row>
                <ion-col>
                  <ion-item v-show="!lastschriftChecked">
                    <div  id="paypalButton"></div>
                  </ion-item>
                </ion-col>
                <ion-col class="ion-text-start">
                  <div v-show="clubInfo && clubInfo.clubInfo && clubInfo.clubInfo.canMeteorPayment && !lastschriftChecked" style="width: 200px;margin: 20px;">      
                    <PaymentButton v-if="slot && slot.priceFloat > 0"
                      :amount="(slot.payRangefee ? calculatedPrice : 0)"
                      @payment-success="handleSuccess"
                        />
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>

          </ion-list>

        <ion-button v-if="(selectedRange && !selectedRange.paymentEnabled)  || (slot && !slot.payRangefee)" style="margin-top: 15px;" expand="block" color="primary" @click="doBooking()">{{ slot.payRangefee && selectedRange.paymentEnabled ? $t('makeAndPayRangeBooking') : $t('makeRangeBooking') }}</ion-button>
      </ion-list>
    </ion-card>
  </ion-content>
</template>

<script>
import { IonButton, IonContent, IonHeader, IonTitle, toastController, IonSelect, IonSelectOption,
IonToolbar, IonLabel, IonInput, IonItem, IonList, IonIcon, IonItemDivider, loadingController,
IonGrid, IonCol, IonRow, modalController, IonCheckbox, IonCard, IonCardHeader, IonCardTitle } from '@ionic/vue';
import { defineComponent, ref, watch } from 'vue';
import { closeOutline, pawSharp, stopCircleOutline, logInOutline, squareSharp, personSharp, 
          personAddOutline, trashOutline, timeOutline, arrowForwardCircleOutline } from 'ionicons/icons';
import { useMutation } from '@vue/apollo-composable'
import saveRangeBookingMutationFile from '../../graphql/saveRangeBooking.mutation.gql'
import createPaymentMutationFile from '../../graphql/createPayment.mutation.gql'
import * as dayjs from 'dayjs';
require('dayjs/locale/de')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.tz.setDefault('Europe/Paris')
dayjs.locale('de')
import { loadScript } from "@paypal/paypal-js";
import { getClubInfo } from '@/composition'
import PaymentButton from "./PaymentButton.vue";

export default defineComponent({
  name: 'EditRangeBookingDialog',
  components: { IonButton, IonContent, IonHeader, IonTitle, IonToolbar,IonLabel, IonInput, IonItem, 
                IonList, IonIcon, IonGrid, IonCol, IonRow, IonItemDivider, IonCheckbox, IonCard, IonCardHeader,
                IonCardTitle, IonSelect, IonSelectOption, PaymentButton
              },
  props: ['propsData'],
  setup() {
    let slot = ref()
    let selectedRange = ref()
    let selectedInterval = ref(0)
    let calculatedPrice = ref(0)
    const clubInfo = ref(getClubInfo())
    const lastschriftChecked = ref(false)


    const { mutate: saveRangeBookingMutation } = useMutation(saveRangeBookingMutationFile, { fetchPolicy: 'no-cache' });
    const { mutate: createPaymentMutation } = useMutation(createPaymentMutationFile, { fetchPolicy: 'no-cache' });

    watch(selectedInterval, async (newInterval, prevInterval)=> {
      if (slot.value.payRangefee == false || selectedRange.value.paymentEnabled == false)
        return
      const slotIndex = selectedRange.value.slots.findIndex(f => f == slot.value)
      const arrayLength = selectedInterval.value * selectedRange.value.intervalDivisor
      calculatedPrice.value = selectedRange.value.slots.slice(slotIndex, slotIndex + arrayLength).reduce((n, {priceFloat}) => n + priceFloat, 0) 
    })

    return {
      saveRangeBookingMutation, 
      dayjs,
      closeOutline, pawSharp, stopCircleOutline, logInOutline, squareSharp, personSharp, personAddOutline,
      trashOutline,timeOutline, slot, selectedRange, selectedInterval, arrowForwardCircleOutline, createPaymentMutation, clubInfo,
      lastschriftChecked, calculatedPrice
    }
  },
  computed: {
      isSuccessfullBraintreePaypalAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreePaypalAuthorized},
      isSuccessfullBraintreeCreditCardAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreeCreditCardAuthorized },
      paymenttype : function(){ 
        return 'PayPalAccount'
/*        if (this.isSuccessfullBraintreePaypalAuthorized && this.isSuccessfullBraintreeCreditCardAuthorized )
          return 'PayPalAccount'
        else if (this.isSuccessfullBraintreePaypalAuthorized)
          return 'PayPalAccount'
        else if (this.isSuccessfullBraintreeCreditCardAuthorized)
          return 'CreditCard' */
       },
  },
  mounted() {
    this.slot = this.propsData.slot
    this.selectedRange = this.propsData.selectedRange
    this.selectedInterval = this.selectedRange.interval_selection[0]
 
    loadScript({ "client-id": this.clubInfo.clubInfo.paypalClientID, currency: this.clubInfo.clubInfo.currency }).then((paypal) => {
    paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'blue',
          layout: 'vertical',
          label: 'pay',
          
        },
        createOrder: async () => {
          const price = this.slot.payRangefee ? this.calculatedPrice : 0
          const p = await this.createPaymentMutation({ description: 'Rangeplätze' + " " + this.selectedRange.selectedItem.name, amount: parseFloat(price), paymentType: 'payPal' })
          if (!p.data.createPayment.success) {
            return ''
          }
          return p.data.createPayment.token
         },
         onError: async (err) => {
            toastController
              .create({
                message: this.$t('invalidPayment'),
                duration: 3000,
                color: 'danger'
              }).then(res => res.present())
         },
         onApprove: async (data,actions) => {
            this.buttonDisabled = true
            loadingController.create().then(res => {
              res.present()
            }).catch(err => { })
            this.saveRangeBookingMutation({ date: this.slot.date, rangeId: this.selectedRange.selectedItem.id, interval: this.selectedRange.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payRangefee ? this.calculatedPrice : 0, paymentType: 'PayPalAccount', language: this.$store.getters.language, orderId: data.orderID })
            .then(res => {
                toastController
                  .create({
                    message: this.$t('bookingAdded'),
                    duration: 3000,
                    color: 'success'
                  }).then(res => res.present())
                  loadingController.dismiss()
                  return modalController.dismiss(true)
            })
            .catch(err => {
                loadingController.dismiss()
                toastController
                  .create({
                    message: this.$t('notSuccessful') + ': ' + err,
                    duration: 3000,
                    color: 'danger'
                  }).then(res => res.present())
            }) 
         },
         onCancel: async () => {
          const price = this.slot.payRangefee ? this.calculatedPrice : 0
          await this.createPaymentMutation({ amount: parseFloat(price), paymentType: 'payPalCancel' })
         }
     }).render("#paypalButton")});

  },
  methods: {
    handleSuccess(result) {
      this.saveRangeBookingMutation({ date: this.slot.date, rangeId: this.selectedRange.selectedItem.id, interval: this.selectedRange.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payRangefee ? this.calculatedPrice : 0, paymentType: 'meteor', language: this.$store.getters.language, orderId: result.id })
      .then(res => {
          toastController
            .create({
              message: this.$t('bookingAdded'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
            return modalController.dismiss(true)
      })
      .catch(err => {
          loadingController.dismiss()
          toastController
            .create({
              message: this.$t('notSuccessful') + ': ' + err,
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
      }) 
    },
    doBooking() {
      loadingController.create().then(res => {
        res.present()
      }).catch(err => { })
      this.saveRangeBookingMutation({ date: this.slot.date, rangeId: this.selectedRange.selectedItem.id, interval: this.selectedRange.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payRangefee ? this.calculatedPrice : 0, paymentType: this.paymenttype, language: this.$store.getters.language })
      .then(res => {
          toastController
            .create({
              message: this.$t('bookingAdded'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
            loadingController.dismiss()
            return modalController.dismiss(true)
      })
      .catch(err => {
          toastController
            .create({
              message: this.$t('notSuccessful') + ': ' + err,
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
      }) 
    },
    closeDialog() {
      return modalController.dismiss()
    },
    createRangeBookingByLastschrift(){      
      this.buttonDisabled = true
      loadingController.create().then(res => {
        res.present()
      }).catch(err => { })
      this.saveRangeBookingMutation({ date: this.slot.date, rangeId: this.selectedRange.selectedItem.id, interval: this.selectedRange.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payRangefee ? this.calculatedPrice : 0, paymentType: 'Lastschrift', language: this.$store.getters.language})
      .then(res => {
          toastController
            .create({
              message: this.$t('bookingAdded'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
            loadingController.dismiss()
            return modalController.dismiss(true)
      })
      .catch(err => {
          loadingController.dismiss()
      }) 
    }
  }
});
</script>